import { render, staticRenderFns } from "./integrity-check-detail.vue?vue&type=template&id=56f1627f"
import script from "./integrity-check-detail.vue?vue&type=script&lang=js"
export * from "./integrity-check-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports